import { fetchData } from "@client";

export async function getCouponQuery() {
  return await fetchData("/company/coupon");
}
